import OrderHistory from './order-history';
import OrderHistoryView from './order-history.view';

export * from './order-history';
export * from './order-history.view';
export * from './order-history.data';
export { IOrderHistoryConfig, IOrderHistoryResources, IOrderHistoryProps } from './order-history.props.autogenerated';
export * from './actions/get-order-shipment-history';
export * from './components/get-sales-order';

export {
    OrderHistory,
    OrderHistoryView
};